const URL_REGEX = /^https?:\/\/.+/

export class DogaUrl {
  private _url: string

  constructor (url: string) {
    if (url !== '' && !URL_REGEX.test(url)) {
      throw new TypeError('Wrong URL provided')
    }
    this._url = url
  }

  url (): string {
    return this._url
  }
}
